import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, useParams, withRouter } from 'react-router-dom';
import { ReactComponent as AccountIcon } from 'Assets/svg/account.svg';
import { ReactComponent as BillingIcon } from 'Assets/svg/billing.svg';
import { ReactComponent as BuyMoreCreditsIcon } from 'Assets/svg/buy-more-credits.svg';
import { ReactComponent as ManageTeamIcon } from 'Assets/svg/manage-team-new.svg';
import { ReactComponent as UsageAnalyticsIcon } from 'Assets/svg/usage-analytic.svg';
import PurchaseStatusPopup from 'Components/common/purchaseStatusPopup';
import { Utils } from 'Utils/utils';
import SideBarNavigation from 'Components/common/sideBarNavigation';
import LoadingWrapper from 'Components/common/loadingWrapper';
import profileState from 'Stores/profile';
import userDetail from 'Stores/userDetail';
import ProfileSettings from './profileSettings/profileSettings';
import ManageBilling from './manageBilling/manageBilling';
import ManageTeam from './manageTeam/manageTeam';
import UsageAnalytics from './usageAnalytics/usageAnalytics';
import BuyMoreCredits from './buyMoreCredits/buyMoreCredits';
import APIUsageChart from './usageAnalytics/APIUsageChart';

const sideBarData = {
  title: 'Account & Billing',
  sublinks: [
    {
      titleText: 'Profile Setting',
      linkKey: 'settings',
      linkValue: '/profile/settings',
      isNavLink: true,
      icon: AccountIcon,
    },
    {
      titleText: 'Manage Team',
      linkKey: 'manage-team',
      linkValue: '/profile/manage-team',
      isNavLink: true,
      icon: ManageTeamIcon,
    },
    {
      titleText: 'Manage Billing',
      linkKey: 'billing',
      linkValue: '/profile/billing',
      isNavLink: true,
      icon: BillingIcon,
    },
    {
      titleText: 'Buy More Credits',
      linkKey: 'buy-more-credits',
      linkValue: '/profile/buy-more-credits',
      isNavLink: true,
      icon: BuyMoreCreditsIcon,
    },
    {
      titleText: 'Credits and Usage',
      linkKey: 'usage-analytics',
      linkValue: '/profile/usage-analytics',
      isNavLink: true,
      icon: UsageAnalyticsIcon,
      subMenu: [
        {
          title: 'Credits Usage',
          link: '/profile/usage-analytics',
        },
      ],
    },
  ],
};

const Profile = observer(props => {
  const { menu = 'settings' } = useParams();
  const { location } = props;
  const [sidebarMenu, setSidebarMenu] = useState(sideBarData);

  const {
    isEnterpriseAdmin,
    noOfSeatsEligible,
    memberSubscription,
  } = userDetail.userInfo;

  const showBilling =
    isEnterpriseAdmin || userDetail.userInfo.memberSubscription === null;

  const showManageTeam =
    isEnterpriseAdmin &&
    Utils.isCreditBasedSubscription() &&
    noOfSeatsEligible > 1;

  const showBuyMoreCredits = Utils.isPaygPlan();

  useEffect(() => {
    const modifiedSideBarData = {
      ...sideBarData,
      sublinks: sideBarData.sublinks.filter(data => {
        if (data.linkKey === 'billing' && !showBilling) return false;
        if (data.linkKey === 'manage-team' && !showManageTeam) return false;
        if (data.linkKey === 'buy-more-credits' && !showBuyMoreCredits)
          return false;
        return true;
      }),
    };

    // to reinstate again after data fix
    if (memberSubscription?.apiEnabled)
      modifiedSideBarData.sublinks.forEach(data => {
        if (data.linkKey === 'usage-analytics' && data.subMenu.length < 2)
          data.subMenu.push({
            title: 'API Usage',
            link: '/profile/usage-analytics/api',
          });
      });
    else
      modifiedSideBarData.sublinks.forEach(data => {
        if (data.linkKey === 'usage-analytics') data.subMenu.splice(0, 1);
      });
    setSidebarMenu(modifiedSideBarData);
  }, []);

  return (
    <div className={`edit-profile ${menu}`}>
      <LoadingWrapper show={profileState.isLoading} position="fixed" />
      <PurchaseStatusPopup />
      <div className="profile-content">
        <SideBarNavigation
          data={sidebarMenu}
          activeMenu={menu}
          collapseInactiveMenu
          selectedSubMenu={
            menu === 'usage-analytics'
              ? location.pathname.includes('api')
                ? 'api usage'
                : 'credits usage'
              : ''
          }
          hasIcon={false}
        />
        <div className="main-section">
          <Switch>
            <Route
              path="/profile/settings"
              exact
              render={routeProps => <ProfileSettings />}
            />
            {showBilling && (
              <Route
                path="/profile/billing"
                exact
                render={routeProps => <ManageBilling />}
              />
            )}
            {showManageTeam && (
              <Route
                path="/profile/manage-team"
                exact
                render={routeProps => <ManageTeam />}
              />
            )}
            {showBuyMoreCredits && (
              <Route
                path="/profile/buy-more-credits"
                exact
                render={routeProps => <BuyMoreCredits />}
              />
            )}
            <Route
              path="/profile/usage-analytics"
              exact
              render={routeProps => <UsageAnalytics />}
            />
            <Route
              path="/profile/usage-analytics/api"
              exact
              render={routeProps => <APIUsageChart />}
            />
          </Switch>
        </div>
      </div>
    </div>
  );
});

export default withRouter(Profile);
